export const appClose = () => {
  location.href = '/application/close'
}
